import { CheckedList } from '../clickCheckbox';

/**
 * 項目選択・解除処理
 *
 * @param {Object} event - チェックボックスのイベントオブジェクト
 * @param {string} event.value - チェックボックスの値
 * @param {boolean} event.checked - チェックボックスの選択状態
 * @param {string[]} categorizedCheckedList - カテゴライズされたチェックリスト
 * @param {keyof CheckedList} targetStateKey - 更新するチェックリストのキー
 * @param {CheckedList} checkedList - 現在のチェックリスト
 * @returns {CheckedList} - 更新されたチェックリスト
 */
export const createCheckedList = (
  event: { value: string; checked: boolean },
  categorizedCheckedList: string[],
  targetStateKey: keyof CheckedList,
  checkedList: CheckedList
) => {
  // 選択処理
  if (event.checked) {
    const newCategorizedCheckedList = [...categorizedCheckedList, event.value];
    return {
      ...checkedList,
      [targetStateKey]: [...new Set(newCategorizedCheckedList)],
    };
  }
  // 選択解除処理
  const deleteCheckedList = categorizedCheckedList.filter(
    (item) => item !== event.value
  );
  return {
    ...checkedList,
    [targetStateKey]: [...new Set(deleteCheckedList)],
  };
};
